import { GlobalStyles } from '@experiences/theme';
import { UiText } from '@experiences/ui-common';
import CheckIcon from '@mui/icons-material/Check';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
    ...GlobalStyles(theme),
    ...createStyles({
        fontSizeM: {
            fontFamily: 'Noto Sans',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '20px',
            color: theme.palette.semantic.colorForeground,
            paddingTop: '6px',
            paddingBottom: '6px',
        },
        checkmarkIcon: {
            color: theme.palette.semantic.colorSuccessIcon,
            marginRight: '11px',
        },
    }),
}));

export const EcommerceCheckListItem: React.FC<{
    translationId: string;
    linkProps?: {
        href: string;
        translationId: string;
        dataCy?: string;
    };
}> = ({
    translationId, linkProps,
}) => {

    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    const renderContent = () => {
        if (linkProps) {
            return translate(
                { id: translationId },
                {
                    0: (
                        <a
                            className={classes.a}
                            href={linkProps.href}
                            data-cy={linkProps.dataCy ?? 'check-list-item-link'}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {translate({ id: linkProps.translationId })}
                        </a>
                    ),
                },
            );
        }

        return translate({ id: translationId });
    };

    return (
        <ListItem
            disableGutters
            className={classes.fontSizeM}>
            <ListItemIcon>
                <CheckIcon
                    fontSize="small"
                    className={classes.checkmarkIcon} />
            </ListItemIcon>
            <UiText>
                {renderContent()}
            </UiText>
        </ListItem>
    );
};
